import {
  fetchDeletePriceBookFailure,
  fetchDeletePriceBookSuccess,
  fetchDeletePriceBookStart,
} from "./reducer";

import { toast } from "react-toastify";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { DELETE_PRICEBOOK } from "../../constants/constants";
import { getPriceBook } from "../GetPriceBook/thunk";

export const deletePriceBook = (id, setLoading) => (dispatch) => {
  setLoading(true);
  dispatch(fetchDeletePriceBookStart());

  determineBaseUrlAndPerformApiCall(
    DELETE_PRICEBOOK(id),
    "DELETE"
  )
    .then((response) => {
      if (!response.error) {
        dispatch(fetchDeletePriceBookSuccess(response));
        dispatch(getPriceBook(setLoading));

        setLoading(false);
        toast.success("Price Book Deleted Successfully");
      } else {
        dispatch(fetchDeletePriceBookFailure(response.error.message));

        setLoading(false);
        toast.error(response.error.message);
      }
    })
    .catch((errorResp) => {
      dispatch(
        fetchDeletePriceBookFailure(
          errorResp?.message || "Something went wrong"
        )
      );

      setLoading(false);
      toast.error(errorResp?.message || "Something went wrong");
    });
};